/**
 * @author: lv.chen
 * @desc: Footer组件
 * @date: 2025/12/15
 */
import React from 'react';
import classnames from 'classnames';
import IMG_LOGO_DATABRAIN from '@intelligence/assets/imgs/casualDailyReports/logo-databrain-big.png';

interface IFooterProps extends IBaseProps {}

const Footer: React.FC<IFooterProps> = (props) => {
  const { style, className } = props;

  return (
    <div style={style} className={classnames('dbi-casual-daily-reports-footer dbi-daily-footer', className)}>
      <img className="dbi-footer-contact-logo" src={IMG_LOGO_DATABRAIN} alt="logo" />
      <div className="dbi-footer-contact-text">有问题请联系 weiwtang或sophiaxwxu</div>
    </div>
  );
};

export default Footer;
